<template>
  <div>
    <div
      class="sbfh"
      style="display:flex;margin-top: 70px;
    margin-left: 20px; justify-content: space-evenly"
      :style="bcharts08Style"
    >
      <div
        v-for="item in echarts08Datas"
        :key="item.EquipmentNo"
        style="width:25%;height:254px;position:relative"
      >
        <echarts10 :echarts10Data="item" :id="item.EquipmentNo"></echarts10>
        <div class="bottom">
          <div class="zhixingtime">
            待执行时间:
            <div class="toperform">{{Math.round((item.UnExcuteTime)*10)/10}}hrs</div>
          </div>
          <div class="tixing"></div>
          <div class="yitime">
            已执行时间:
            <div class="executetime">{{item.ExcutedTime}}hrs</div>
          </div>
          <div class="sumtask">
            总执行任务:
            <span>{{item.ExcutedCount+item.UnExcuteCount}}个</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts10 from "./echarts4";
export default {
  name: "ecahrts09",
  props: {
    bcharts08Style: {
      type: Object,
      default: () => {
        return { width: "439px", height: "254px" };
      }
    },
    echarts08Data: {
      type: Array,
    }
  },
  data() {
    return {
      echarts08Datas:this.echarts08Data
    };
  },
  watch:{
    echarts08Data:{
      handler(newval, oldval) {
        this.echarts08Datas = newval
      },
      deep: true
    }
  },
  mounted() {
  },
  components: {
    echarts10
  },
  destroyed() {},
  methods: {}
};
</script>
<style scoped>
.bottom {
  position: absolute;
  width: 105px;
  height: 110px;
  bottom: 0px;
  margin-left: 3px;
  text-align: center;
}

.zhixingtime {
  color: #000;
  width: 95px;
  height: 22px;
  font-size: 12px;
}
.tixing {
  width: 95px;
  height: 19px;
  position: absolute;
  top: 14px;
  background: url("../../assets/img/tixing.png") no-repeat;
}
.toperform {
  font-size: 14px;
  color: #eda72e;
}
.yitime {
  margin-top: 15px;
  width: 100px;
  font-size: 10px;
  color: #000;
}
.executetime {
  font-size: 14px;
  color: #9f8646;
}
.sumtask {
  height: 30px;
  font-size: 10px;
  line-height: 30px;
  background-color: #9f8646;
  color: #fff;
}
.sumtask span {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts3.vue